import { render, staticRenderFns } from "./ReportMarketValue.vue?vue&type=template&id=32fb0d06&"
import script from "./ReportMarketValue.vue?vue&type=script&lang=js&"
export * from "./ReportMarketValue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports